import { formatNumber, formatPercentage, getSeparators, normalizeNumericStr } from '@/locale/i18n'

export { formatNumber, formatPercentage, getSeparators, normalizeNumericStr }

/**
 * Renders a per-share price as whole cents ("65¢"). Prices carry two decimals of a
 * currency unit, so whole cents keep every digit the source value has. Rounds before
 * formatting: `value * 100` lands just under the whole cent in binary floating point
 * (0.29 → 28.999…) and formatNumber floors by default.
 */
export const formatPriceInCents = value =>
  value == null ? '-' : `${formatNumber(Math.round(value * 100), { maximumFractionDigits: 0 })}¢`

/**
 * Abbreviates values over 4 digits with "K" (thousands) / "M" (millions), returning the
 * scaled value and its suffix separately so the caller can format the number in its own
 * locale and currency. For compact volume/liquidity figures, where the full integer does
 * not fit; `skip` keeps it whole, as tooltips and the market page need.
 */
export const abbreviateAmount = (value, skip = false) => {
  const abs = Math.abs(value)
  if (!skip && abs >= 1_000_000) return { value: value / 1_000_000, abbr: 'M' }
  if (!skip && abs >= 10_000) return { value: value / 1_000, abbr: 'K' }
  return { value, abbr: '' }
}
